import React, { useState } from 'react';
import { CrudStyles } from '../shared/Crud';
import DeliveryCostCenterSelectorModal from '../Deliveries/steps/DeliveryCostCenterSelectorModal';
import { FieldHint, FilterField } from './styles';

const { Button } = CrudStyles;

const badgeStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '6px 10px',
    background: '#eff6ff',
    border: '1px solid #bfdbfe',
    borderRadius: '4px',
    fontSize: '13px',
    color: '#1e40af',
    maxWidth: '100%',
};

const clearButtonStyle = {
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    padding: '0 2px',
    fontSize: '14px',
    lineHeight: 1,
    color: '#1e40af',
};

const MISSING_CUSTOMER_HINT = 'Selecione o cliente para escolher o centro de custo.';

/**
 * Campo de filtro de centro de custo: reutiliza a lista paginada de
 * DeliveryCostCenterSelectorModal. Depende do cliente, pois os centros de custo
 * são listados por pessoa jurídica.
 */
export default function ReportCostCenterFilter({
    label = 'Centro de custo',
    customerId,
    costCenterId,
    costCenterName = '',
    onSelect,
    disabled = false,
    error,
    hint,
    modalZIndex = 10050,
}) {
    const [modalOpen, setModalOpen] = useState(false);
    const hasCustomer = customerId != null && String(customerId).trim() !== '';
    const hasSelection = costCenterId != null && String(costCenterId).trim() !== '';
    const hasError = Boolean(error);

    return (
        <>
            <FilterField $hasError={hasError}>
                <span>{label}</span>
                {hasSelection ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        <div style={badgeStyle} title={costCenterName || undefined}>
                            <span
                                style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {costCenterName || `Centro de custo #${costCenterId}`}
                            </span>
                            <button
                                type="button"
                                onClick={() => onSelect?.(null)}
                                disabled={disabled}
                                style={clearButtonStyle}
                                aria-label="Remover filtro de centro de custo"
                                title="Remover filtro de centro de custo"
                            >
                                ✕
                            </button>
                        </div>
                        <Button
                            type="button"
                            variant="outline"
                            disabled={disabled || !hasCustomer}
                            onClick={() => setModalOpen(true)}
                            style={{ alignSelf: 'flex-start' }}
                        >
                            Alterar centro de custo
                        </Button>
                    </div>
                ) : (
                    <Button
                        type="button"
                        variant="outline"
                        disabled={disabled || !hasCustomer}
                        onClick={() => setModalOpen(true)}
                        style={{ alignSelf: 'flex-start' }}
                        title={hasCustomer ? undefined : MISSING_CUSTOMER_HINT}
                    >
                        Selecionar centro de custo
                    </Button>
                )}
                {(hasError || !hasCustomer || hint) && (
                    <FieldHint $error={hasError}>
                        {error || (hasCustomer ? hint : MISSING_CUSTOMER_HINT)}
                    </FieldHint>
                )}
            </FilterField>

            <DeliveryCostCenterSelectorModal
                open={modalOpen && hasCustomer}
                customerId={customerId}
                currentCostCenterId={hasSelection ? costCenterId : null}
                zIndex={modalZIndex}
                onClose={() => setModalOpen(false)}
                onSelectCostCenter={(costCenter) => {
                    if (costCenter?.id == null) return;
                    onSelect?.({
                        id: costCenter.id,
                        name: costCenter.name ?? `Centro de custo #${costCenter.id}`,
                    });
                    setModalOpen(false);
                }}
                onRemoveCostCenter={() => {
                    onSelect?.(null);
                    setModalOpen(false);
                }}
                removalConfirmMessage="Deseja remover o filtro de centro de custo?"
                removeButtonTitle="Remover filtro de centro de custo"
            />
        </>
    );
}
